export const getDataSource = (resAst: Ast) => {
  const dataRes = resAst.children.filter(
    (item) => item.tag.indexOf('Data') > -1
  );
  const dataSource: string[] = [];
  dataRes.map((item: Ast) => {
    if (item.tag === 'DataItemText') {
      item.children.map((textItem) => {
        const { source } = textItem.attrsMap;
        if (dataSource.findIndex((item) => item === source) < 0)
          dataSource.push(source);
      });
    } else {
      const { source } = item.attrsMap;
      if (
        source &&
        source !== '' &&
        dataSource.findIndex((item) => item === source) < 0
      )
        dataSource.push(source);
    }
  });
  return dataSource;
};
